export const changePasswordModal = {
	content: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',

		width: '100%',

		'@media (max-width: 639.98px)': {
			// paddingBottom: '20px',
		},
	},

	fieldWrap: {
		marginBottom: '16px',
	},

	formWrap: {
		width: '100%',
	},

	containedBlue: {
		background: 'var(--primary-500)',
	},

	iconWrap: {
		marginBottom: '32px',
	},

	contentWrap: {
		marginBottom: '32px',
	},

	title: {
		textAlign: 'center',
	},

	description: {
		textAlign: 'center',
		color: 'var(--neutral-300)',
		fontSize: '16px',
	},

	btnWrap: {
		display: 'flex',
		justifyContent: 'space-between',
		width: '100%',
		gap: '16px',

		'@media (max-width: 639.98px)': {
			maxWidth: '100%',
			flexDirection: 'column',
			gap: '16px',
		},
	},

	btn: {
		width: '100%',
	},
};
